(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["limonjoy-colour-family"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lj-colour-family')) {
    customElements.define(
      'lj-colour-family',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.observer?.disconnect();

          this.controller = new AbortController();

          this.track = this.querySelector('[data-family-track]');
          this.items = Array.from(
            this.querySelectorAll('[data-family-item]')
          );

          this.nav = this.querySelector('[data-family-nav]');
          this.prev = this.querySelector('[data-family-prev]');
          this.next = this.querySelector('[data-family-next]');

          if (!this.track || !this.items.length) return;

          const signal = this.controller.signal;

          const schedule = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          };

          this.prev?.addEventListener(
            'click',
            () => this.move(-1),
            { signal }
          );

          this.next?.addEventListener(
            'click',
            () => this.move(1),
            { signal }
          );

          this.track.addEventListener(
            'scroll',
            schedule,
            { passive: true, signal }
          );

          this.track.addEventListener(
            'keydown',
            event => {
              if (event.target !== this.track) return;

              const rtl =
                getComputedStyle(this.track).direction === 'rtl';

              if (
                event.key === 'ArrowRight' ||
                event.key === 'ArrowLeft'
              ) {
                event.preventDefault();

                this.move(
                  (event.key === 'ArrowRight' ? 1 : -1) *
                  (rtl ? -1 : 1)
                );
              } else if (
                event.key === 'Home' ||
                event.key === 'End'
              ) {
                event.preventDefault();

                this.reveal(
                  event.key === 'Home'
                    ? this.items[0]
                    : this.items[this.items.length - 1]
                );
              }
            },
            { signal }
          );

          this.addEventListener(
            'shopify:block:select',
            event => {
              const item = event.target.closest('[data-family-item]');

              if (item && this.contains(item)) {
                this.reveal(item, 'auto');
              }
            },
            { signal }
          );

          this.observer = new ResizeObserver(schedule);
          this.observer.observe(this.track);

          schedule();
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.observer?.disconnect();
          cancelAnimationFrame(this.frame);
        }

        distance(item) {
          const view = this.track.getBoundingClientRect();
          const rect = item.getBoundingClientRect();

          return getComputedStyle(this.track).direction === 'rtl'
            ? view.right - 4 - rect.right
            : rect.left - view.left - 4;
        }

        reveal(item, behavior) {
          if (!item) return;

          const rtl =
            getComputedStyle(this.track).direction === 'rtl';

          const reduce = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

          this.track.scrollBy({
            left: this.distance(item) * (rtl ? -1 : 1),
            behavior: behavior || (reduce ? 'auto' : 'smooth')
          });
        }

        move(direction) {
          const candidates =
            direction > 0 ? this.items : [...this.items].reverse();

          const target = candidates.find(item =>
            direction > 0
              ? this.distance(item) > 2
              : this.distance(item) < -2
          );

          this.reveal(target);
        }

        update() {
          if (!this.nav) return;

          const overflow =
            this.track.scrollWidth > this.track.clientWidth + 2;

          this.nav.hidden = !overflow;

          const view = this.track.getBoundingClientRect();
          const first = this.items[0].getBoundingClientRect();
          const last =
            this.items[this.items.length - 1].getBoundingClientRect();

          const rtl =
            getComputedStyle(this.track).direction === 'rtl';

          this.prev.disabled =
            !overflow ||
            (
              rtl
                ? first.right <= view.right - 2
                : first.left >= view.left + 2
            );

          this.next.disabled =
            !overflow ||
            (
              rtl
                ? last.left >= view.left + 2
                : last.right <= view.right - 2
            );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limonjoy-craft-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lj-craft-journey')) {
    customElements.define(
      'lj-craft-journey',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.swipe = null;
          this.controller = new AbortController();

          this.tabs = Array.from(
            this.querySelectorAll('[data-craft-step]')
          );

          this.panels = Array.from(
            this.querySelectorAll('[data-craft-panel]')
          );

          this.previousButton = this.querySelector(
            '[data-craft-previous]'
          );

          this.nextButton = this.querySelector(
            '[data-craft-next]'
          );

          this.currentLabel = this.querySelector(
            '[data-craft-current]'
          );

          this.status = this.querySelector(
            '[data-craft-status]'
          );

          this.frame = this.querySelector(
            '.lj-craft-journey__frame'
          );

          if (!this.tabs.length || !this.panels.length) return;

          const signal = this.controller.signal;

          this.frame?.addEventListener(
            'touchstart',
            event => this.onSwipeStart(event),
            { passive: true, signal }
          );

          this.frame?.addEventListener(
            'touchmove',
            event => this.onSwipeMove(event),
            { passive: true, signal }
          );

          this.frame?.addEventListener(
            'touchend',
            event => this.onSwipeEnd(event),
            { passive: true, signal }
          );

          this.frame?.addEventListener(
            'touchcancel',
            () => {
              this.swipe = null;
            },
            { passive: true, signal }
          );

          this.tabs.forEach((tab, index) => {
            tab.addEventListener(
              'click',
              () => this.activate(index),
              { signal }
            );

            tab.addEventListener(
              'keydown',
              event => this.onKeydown(event, index),
              { signal }
            );
          });

          this.previousButton?.addEventListener(
            'click',
            () => this.activate(this.activeIndex - 1),
            { signal }
          );

          this.nextButton?.addEventListener(
            'click',
            () => this.activate(this.activeIndex + 1),
            { signal }
          );

          this.addEventListener(
            'shopify:block:select',
            event => {
              const selected = event.target.closest(
                '[data-craft-step]'
              );

              if (!selected || !this.contains(selected)) return;

              this.activate(
                this.tabs.indexOf(selected),
                true
              );
            },
            { signal }
          );

          const selectedIndex = this.tabs.findIndex(
            tab => tab.getAttribute('aria-selected') === 'true'
          );

          this.activate(
            selectedIndex < 0 ? 0 : selectedIndex
          );
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.swipe = null;
        }

        onSwipeStart(event) {
          this.swipe = null;

          if (
            !window.matchMedia('(max-width: 767px)').matches ||
            event.touches.length !== 1 ||
            this.tabs.length < 2 ||
            (window.visualViewport?.scale || 1) > 1.05
          ) {
            return;
          }

          const touch = event.touches[0];

          this.swipe = {
            id: touch.identifier,
            x: touch.clientX,
            y: touch.clientY,
            axis: null
          };
        }

        onSwipeMove(event) {
          if (!this.swipe) return;

          if (event.touches.length !== 1) {
            this.swipe = null;
            return;
          }

          const touch = Array.from(event.touches).find(
            item => item.identifier === this.swipe.id
          );

          if (!touch) return;

          const dx = Math.abs(
            touch.clientX - this.swipe.x
          );

          const dy = Math.abs(
            touch.clientY - this.swipe.y
          );

          if (
            !this.swipe.axis &&
            Math.max(dx, dy) >= 10
          ) {
            if (dy >= dx) {
              this.swipe = null;
            } else if (dx > dy * 1.25) {
              this.swipe.axis = 'x';
            }
          }
        }

        onSwipeEnd(event) {
          const swipe = this.swipe;
          this.swipe = null;

          if (
            !swipe ||
            event.touches.length ||
            !window.matchMedia('(max-width: 767px)').matches ||
            (window.visualViewport?.scale || 1) > 1.05
          ) {
            return;
          }

          const touch = Array.from(
            event.changedTouches
          ).find(
            item => item.identifier === swipe.id
          );

          if (!touch) return;

          const dx = touch.clientX - swipe.x;
          const dy = touch.clientY - swipe.y;

          const threshold = Math.max(
            36,
            Math.min(72, this.frame.clientWidth * 0.12)
          );

          if (
            Math.abs(dx) < threshold ||
            Math.abs(dx) <= Math.abs(dy) * 1.25
          ) {
            return;
          }

          const direction =
            getComputedStyle(this).direction === 'rtl'
              ? -1
              : 1;

          this.activate(
            this.activeIndex +
              (dx < 0 ? 1 : -1) * direction
          );
        }

        activate(index, focus = false) {
          const nextIndex = Math.max(
            0,
            Math.min(index, this.tabs.length - 1)
          );

          this.activeIndex = nextIndex;

          this.tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === nextIndex;

            tab.setAttribute(
              'aria-selected',
              active ? 'true' : 'false'
            );

            tab.setAttribute(
              'tabindex',
              active ? '0' : '-1'
            );
          });

          this.panels.forEach((panel, panelIndex) => {
            const active = panelIndex === nextIndex;

            panel.classList.toggle(
              'is-active',
              active
            );

            panel.setAttribute(
              'aria-hidden',
              active ? 'false' : 'true'
            );
          });

          const displayIndex = String(
            nextIndex + 1
          ).padStart(2, '0');

          const progress =
            ((nextIndex + 1) / this.tabs.length) * 100;

          if (this.currentLabel) {
            this.currentLabel.textContent = displayIndex;
          }

          this.style.setProperty(
            '--journey-progress',
            `${progress}%`
          );

          if (this.previousButton) {
            this.previousButton.disabled =
              nextIndex === 0;
          }

          if (this.nextButton) {
            this.nextButton.disabled =
              nextIndex === this.tabs.length - 1;
          }

          if (this.status) {
            const title = this.tabs[nextIndex].querySelector(
              '.lj-craft-journey__step-title'
            );

            this.status.textContent = title
              ? `${displayIndex}. ${title.textContent.trim()}`
              : displayIndex;
          }

          if (focus) {
            this.tabs[nextIndex].focus({
              preventScroll: true
            });
          }
        }

        onKeydown(event, index) {
          let targetIndex = index;

          if (
            event.key === 'ArrowRight' ||
            event.key === 'ArrowDown'
          ) {
            targetIndex = index + 1;
          }

          if (
            event.key === 'ArrowLeft' ||
            event.key === 'ArrowUp'
          ) {
            targetIndex = index - 1;
          }

          if (event.key === 'Home') {
            targetIndex = 0;
          }

          if (event.key === 'End') {
            targetIndex = this.tabs.length - 1;
          }

          if (targetIndex === index) return;

          event.preventDefault();
          this.activate(targetIndex, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limonjoy-floating-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lj-original-floating-carousel')) {
    customElements.define('lj-original-floating-carousel', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.sequence = (this.sequence || 0) + 1;
        this.animation?.cancel();
      }
      initialize() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.stage = this.querySelector('[data-fic-stage]');
        this.track = this.querySelector('[data-fic-stage-track]');
        this.cardsTrack = this.querySelector('[data-fic-cards-track]');
        this.cards = [...this.querySelectorAll('[data-fic-card]')];
        if (!this.stage || !this.cards.length) return;
        this.background = this.querySelector('[data-fic-background]');
        this.previous = this.querySelector('[data-fic-prev]');
        this.next = this.querySelector('[data-fic-next]');
        this.live = this.querySelector('[data-fic-live]');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.desktopQuery = matchMedia('(min-width: 990px)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.current = 0;
        this.showBackground = !!this.background;
        this.sequence = 0;
        this.busy = false;
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.stage.addEventListener('keydown', event => {
          if (event.target !== this.stage || !this.desktopQuery.matches) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.navigate(0, !!this.background);
          else if (event.key === 'End') this.navigate(this.lastIndex(), false);
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-fic-card]');
          const index = this.cards.indexOf(card);
          if (index < 0) return;
          if (this.desktopQuery.matches) this.navigate(index, false, true);
          else this.cardsTrack.scrollTo({ left: card.offsetLeft, behavior: 'instant' });
        }, { signal });
        this.cardsTrack.addEventListener('scroll', () => {
          if (this.desktopQuery.matches) return;
          const center = this.cardsTrack.getBoundingClientRect().left;
          let nearest = 0;
          let distance = Infinity;
          this.cards.forEach((card, index) => {
            const delta = Math.abs(card.getBoundingClientRect().left - center);
            if (delta < distance) { distance = delta; nearest = index; }
          });
          if (nearest !== this.current) { this.current = nearest; this.announce(); }
        }, { passive: true, signal });
        this.desktopQuery.addEventListener('change', () => {
          this.sequence++;
          this.animation?.cancel();
          this.busy = false;
          this.current = 0;
          this.showBackground = !!this.background;
          this.cardsTrack.scrollLeft = 0;
          this.applyState();
        }, { signal });
        this.motionQuery.addEventListener('change', () => {
          this.sequence++;
          this.animation?.cancel();
          this.busy = false;
          this.applyState();
        }, { signal });
        this.observer = new ResizeObserver(() => {
          if (this.busy) return;
          this.current = Math.min(this.current, this.lastIndex());
          this.applyState();
        });
        this.observer.observe(this.stage);
        this.classList.add('is-ready');
        this.applyState();
      }
      lastIndex() {
        if (!this.cards.length) return 0;
        const width = this.cards[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.cardsTrack).columnGap) || 16;
        const visible = Math.max(1, Math.floor((this.stage.clientWidth + gap) / (width + gap)));
        return Math.max(0, this.cards.length - visible);
      }
      offset(index) {
        return this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      }
      applyState() {
        const desktop = this.desktopQuery.matches;
        const target = desktop && !this.showBackground ? -this.offset(this.current) : 0;
        this.track.style.transform = `translate3d(${target}px,0,0)`;
        this.background?.classList.toggle('is-passed', desktop && !this.showBackground);
        this.cards.forEach((card, index) => {
          const passed = desktop && !this.showBackground && index < this.current;
          card.classList.toggle('is-passed', passed);
          card.inert = passed;
          if (passed) card.setAttribute('aria-hidden', 'true');
          else card.removeAttribute('aria-hidden');
        });
        this.previous.hidden = !desktop || (this.background ? this.showBackground : this.current === 0);
        this.next.hidden = !desktop || (!this.showBackground && this.current >= this.lastIndex());
        this.previous.disabled = this.busy;
        this.next.disabled = this.busy;
        if (this.busy) this.setAttribute('aria-busy', 'true');
        else this.removeAttribute('aria-busy');
      }
      move(direction) {
        if (this.busy || !this.desktopQuery.matches) return;
        if (direction > 0) {
          if (this.showBackground) this.navigate(0, false);
          else if (this.current < this.lastIndex()) this.navigate(this.current + 1, false);
        } else if (!this.showBackground) {
          if (this.current > 0) this.navigate(this.current - 1, false);
          else if (this.background) this.navigate(0, true);
        }
      }
      async navigate(index, showBackground, instant = false) {
        if (this.busy && !instant) return;
        const sequence = ++this.sequence;
        this.animation?.cancel();
        index = Math.max(0, Math.min(index, this.cards.length - 1));
        const animate = !instant && !this.motionQuery.matches;
        const from = this.track.style.transform || 'translate3d(0px,0,0)';
        const outgoing = !showBackground && (this.showBackground || index > this.current)
          ? (this.showBackground ? this.background : this.cards[this.current]) : null;
        this.busy = true;
        this.applyState();
        if (outgoing && animate && typeof outgoing.animate === 'function') {
          this.animation = outgoing.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 220, easing: 'ease-out', fill: 'forwards' });
          await this.animation.finished.catch(() => {});
          if (!this.isConnected || sequence !== this.sequence) return;
          outgoing.classList.add('is-passed');
          this.animation.cancel();
        }
        this.current = index;
        this.showBackground = showBackground;
        this.applyState();
        const to = this.track.style.transform;
        if (animate && from !== to && typeof this.track.animate === 'function') {
          this.animation = this.track.animate([{ transform: from }, { transform: to }], { duration: 640, easing: 'cubic-bezier(0.4,0,0.2,1)' });
          await this.animation.finished.catch(() => {});
          if (!this.isConnected || sequence !== this.sequence) return;
          this.animation.cancel();
        }
        if (!this.isConnected || sequence !== this.sequence) return;
        this.busy = false;
        this.applyState();
        this.announce();
      }
      announce() {
        if (this.live) this.live.textContent = this.cards[this.current]?.querySelector('[data-fic-card-heading]')?.textContent.trim() || '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
